/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExamSharingPageService } from '@app/di/exam-sharing/exam-sharing-page.service';
import { first } from 'rxjs/operators';
import { UserPreferenceService } from '@app/common/user-preference.service';

@Component({
  selector: 'app-exam-sharing',
  templateUrl: './exam-sharing-page.component.html',
  styleUrls: ['./exam-sharing-page.component.less']
})
export class ExamSharingPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    public examSharingService: ExamSharingPageService,
    private userPreferencesService: UserPreferenceService
  ) {
    this.userPreferencesService.applyTheme();
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(first()).subscribe(params => {
      const urlParam = params['id'];
      this.examSharingService.initiateExternalShare(urlParam);
    });
  }
}
